import { faker } from '@faker-js/faker'
import { Factory } from 'miragejs'

export default Factory.extend({
  address1() {
    return faker.location.streetAddress()
  },
  faxNumber() {
    return faker.phone.number()
  },
  phoneNumber() {
    return faker.phone.number()
  },
  state() {
    return faker.location.state()
  },
  town() {
    return faker.location.city()
  },
})
